module.exports = __webpack_public_path__ + "static/media/fox-business.f26c6572.jpg";